import React, { Component } from 'react';
import { connect } from "react-redux";
import {changeBasicFields} from "../../../store/actions/route";

const BasicSettings = ({ namespace, routeName, changeBasicFields }) => {

  const endpointLink = wpApiSettings.root + (namespace && routeName ? namespace + '/' + routeName : '');

	return (
		<div className="wrap RouteName">

			<div className="RestRoutesField">
				<label>Namespace: </label>
				<input
					onChange={ e => changeBasicFields( 'namespace', e.target.value ) }
					type="text"
					value={namespace}
					className="regular-text namespace"
				/>
        <small>For example: v1/my-company</small>
			</div>

			<div className="RestRoutesField">
				<label>Route Name: </label>
				<input
					onChange={ e => changeBasicFields( 'routeName', e.target.value ) }
					type="text"
					value={routeName}
					className="regular-text routeName"
				/>
        <small>For example: products/list</small>
			</div>
      <div className="clear"></div>

      <h4>Custom endpoint URL (after save): <a target={"_blank"} href={endpointLink}>{endpointLink}</a></h4>
		</div>
	);
};

const mapStateToProps = state => ({namespace: state.settings.namespace, routeName: state.settings.routeName});

const mapDispatchToProps = dispatch => ({
	changeBasicFields: ( fieldName, fieldValue ) => dispatch( changeBasicFields( fieldName, fieldValue ) )
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicSettings)
